import React,{useState,useEffect} from 'react';
import ProfilePic from '../../ui-elements/ProfilePic';
import Axios from 'axios';
import LoaderCircle from '../../ui-elements/LoaderCircle';
import AlimModalMedium from '../../ui-elements/AlimModalMedium';
import EditComment from '../EditComment';

const CommentBlock=({first_name, second_name, comment_time, comment_data, handleLike, comment_id, like_count, cmnt_count, vol_num, book_num, hadith_num, modalFunc, comment_level, comment_mode,col_num,home_page,profile_pic,user_id, comment_cat, title_func, nav_link_func,webToken,comment_user,current_user,comment_visibility, comment_parent, root_parent, lastInteractionTime, involvementCount})=>{
    const [likeCount,setLikeCount]=useState(Number(like_count));
    const [likeStatus,setLikeStatus]=useState("loading");
    const [tileTitle,setTileTitle]=useState(`Hadith [${comment_cat?`${comment_cat}:`:``}${vol_num}:${book_num}:${hadith_num}]`);
    const [commentContent,setCommentContent]=useState(comment_data);
    const [isEditModalOpen,setIsEditModalOpen]=useState(false);
    const [alimToken,setAlimToken]=useState(webToken);
    const [loggedUser,setLoggedUser]=useState(current_user);

    const getLikeStatus=()=>{
        if(typeof alimToken!=="undefined"&&alimToken!==null)
        {
            Axios.post(`${alimAPIBaseURI}rpc/get_comment_like_status`,{cmnt_id:comment_id},{headers: {"Content-Type": "application/json","Authorization":`bearer ${alimToken}`}}).then((data)=>{
                setLikeStatus(data.data);
            }).catch((error)=>{
                console.log(error);
                setLikeStatus("error");
            });
        }
        else
        {
            setLikeStatus("error");
        }
    }

    const doLike=(cmntId)=>{
        Axios.post(`${alimAPIBaseURI}rpc/post_hadith_like`, {cmntid:cmntId},{headers: {"Content-Type": "application/json","Authorization":`bearer ${alimToken}`}}).then((data)=>{
            setLikeStatus("like");
            setLikeCount(likeCount+1);
        }).catch((error)=>{
            window.location="/login";
        });
    }

    const doDislike=(cmntId)=>{
        Axios.post(`${alimAPIBaseURI}rpc/post_hadith_dislike`, {cmntid:cmntId},{headers: {"Content-Type": "application/json","Authorization":`bearer ${alimToken}`}}).then((data)=>{
            setLikeStatus("dislike");
            setLikeCount(likeCount-1);
        }).catch((error)=>{
            window.location="/login";
        });
    }

    const doLikeUpdate=(cmntId)=>{
        Axios.post(`${alimAPIBaseURI}rpc/post_hadith_like_update`, {cmntid:cmntId},{headers: {"Content-Type": "application/json","Authorization":`bearer ${alimToken}`}}).then((data)=>{
            setLikeStatus("like");
            setLikeCount(likeCount+1);
        }).catch((error)=>{
            window.location="/login";
        });
    }

    const likeFunc=(cmntId,likeStatus)=>{
        if(alimToken!==null&&alimToken!==undefined)
        {
            setLikeStatus("loading");
            if(likeStatus==="like")
            {
                doDislike(cmntId);
            }
            else if(likeStatus==='dislike')
            {
                doLikeUpdate(cmntId);
            }
            else
            {
                doLike(cmntId);
            }
        }
        else
        {
            window.location="/login";
        }
    }

    useEffect(()=>{
        const loginHandler=()=>{
            setAlimToken(localStorage.getItem('alim-login-token'));
            setLoggedUser(localStorage.getItem('alim-user-email'));
        }
        document.addEventListener("alim-login",loginHandler);

        return()=>{
            document.removeEventListener("alim-login", loginHandler);
        }
    });

    useEffect(()=>{},[likeCount,likeStatus,commentContent,loggedUser]);

    useEffect(()=>{
        getLikeStatus();
    },[alimToken]);

    useEffect(()=>{
        if(title_func&&comment_cat)
        {
            setTileTitle(title_func(comment_cat,vol_num,book_num,hadith_num));
        }
    },[]);

    if(home_page==="1"&&col_num!=="2")
    {
        return (
            <a href={'/comments/view-hadith-comment?cmroot='+comment_id} target='_blank' rel='noopener noreferrer' className={`${home_page==="0"?"bg-light-beige dark:bg-light-blue":""} ${home_page==="1"?"blue-gr-box":""} ${home_page==="2"?"bg-light-beige dark:bg-deep-blue":""} rounded-lg px-5 py-3 ${col_num==="2"?"col-span-12 md:col-span-6":"col-span-12 md:col-span-6 lg:col-span-4"}`}>
                {
                    <h4 className='font-light text-[18px] truncate'>Posted in {`${tileTitle}`}</h4>
                }
                <div className='flex gap-1'>
                    <span className='text-xs block mt-[5px]'>{comment_time ?? 'Just now'},</span>
                    <span className='text-xs block mt-[5px]'>Last involvement: {lastInteractionTime ?? ''}</span>
                </div>
                <div className='min-h-[116px]'>
                    <p className={`mt-4 text-sm mb-2 line-clamp-3`}>
                        {
                            comment_data
                        }
                    </p>
                    {comment_data.length>150?< button className='text-sm mb-4 underline'>Read more</button>:null}
                </div>
                
                <div className='flex justify-between'>
                    <div className='flex gap-3 items-center grow min-w-0'>
                        <div className='w-fit h-fit rounded-full bg-light-beige dark:bg-dark_blue flex justify-center items-center'>
                            <ProfilePic profilePic={profile_pic}></ProfilePic>
                        </div>
                        <p className='py-4 text-base font-light truncate'>
                            {first_name===null&&second_name===null?'Guest User':`${first_name} ${second_name}`}
                        </p>
                    </div>
    
                    <div className='flex gap-3 cursor-pointer items-center'>
                        {
                            involvementCount?
                                <div className='flex gap-2' title='Total users involved'>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
                                    </svg>
                                    <span>{involvementCount}</span>
                                </div>
                            :
                                null
                        }
                        {
                            likeStatus!=="loading"?
                                comment_mode==='post'&&likeStatus!=="error"?
                                    <div className='flex gap-2 cursor-pointer'>
                                        {
                                            likeStatus!==null&&likeStatus!=="dislike"?<img src='/images/heart-solid.svg' width="17" height="17" alt="Liked" title='Dislike' onClick={()=>{likeFunc(comment_id,likeStatus)}}/>:<div className='heart-empty-img-elem w-[17px] h-[17px] mt-1' title='Like' onClick={()=>{likeFunc(comment_id,likeStatus)}}></div>
                                        }
                                        <span>{likeCount}</span>
                                    </div>
                                :
                                    <div className='flex gap-2'>
                                        {
                                            <div className='heart-empty-img-elem w-[17px] h-[17px] mt-1'></div>
                                        }
                                        <span>{like_count}</span>
                                    </div>
                            :
                                <LoaderCircle/>
                        }
    
                        {
                            modalFunc?
                            <div className='flex gap-2' onClick={()=>{}}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" strokeWidth={1.5} stroke="currentColor" className="w-[17px] h-[17px] mt-1">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                </svg>
                                <span>{cmnt_count===null?"0":cmnt_count}</span>
                            </div>
                            :
                            <button href={'/comments/view-hadith-comment?cmroot='+comment_id} target='_blank' className='flex gap-2' title='Post reply'>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" strokeWidth={1.5} stroke="currentColor" className="w-[17px] h-[17px] mt-1">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                </svg>
                                <span>{cmnt_count===null?"0":cmnt_count}</span>
                            </button>
                        }
                    </div>
                </div>
            </a>
        );
    }
    else
    {
        return (
            <div className={`${home_page==="0"?"bg-light-beige dark:bg-light-blue":""} ${home_page==="1"?"blue-gr-box":""} ${home_page==="2"?"bg-light-beige dark:bg-deep-blue":""} rounded-lg px-5 py-3 ${col_num==="2"?"col-span-12 md:col-span-6":"col-span-12 md:col-span-6 lg:col-span-4"}`}>
                {
                    nav_link_func?
                    <a href={nav_link_func(comment_cat,vol_num,book_num,hadith_num)} target='_blank' rel='noopener noreferrer' className='inline-flex max-w-full'>
                        <h4 className='font-light text-[18px] truncate hover:text-deep-red'>Posted in {`${tileTitle}`}</h4>
                    </a>
                    :
                    <h4 className='font-light text-[18px] truncate'>Posted in {`${tileTitle}`}</h4>
                }
                <div className='flex gap-1'>
                    <span className='text-xs block mt-[5px]'>{comment_time ?? 'Just now'},</span>
                    <span className='text-xs block mt-[5px]'>Last involvement: {lastInteractionTime ?? ''}</span>
                </div>
                <div className='min-h-[50px] md:min-h-[116px]'>
                    <p className={`mt-4 text-sm mb-2 line-clamp-3 ${commentContent?``:`opacity-75`}`}>
                        {
                            commentContent?
                                commentContent
                            :
                                `Comment blocked by Admin.`
                        }
                    </p>
                    {comment_data.length>150?<a href={'/comments/view-hadith-comment?cmroot='+comment_id} className='text-sm mb-4 underline' target="_blank" rel="noopener noreferrer">Read more</a>:null}
                </div>
                
                <div className='flex justify-between'>
                    <div className='flex gap-3 items-center grow min-w-0'>
                        <div className='w-fit h-fit rounded-full bg-light-beige dark:bg-dark_blue flex justify-center items-center'>
                            <ProfilePic profilePic={profile_pic}></ProfilePic>
                        </div>
                        <p className='my-4 text-base md:text-lg leading-5 font-light line-clamp-2'>
                        {first_name===null&&second_name===null?'Guest User':`${first_name} ${second_name}`}
                        </p>
                    </div>
                    {
                        ((typeof comment_visibility!=='undefined'&&comment_visibility!==0)||!commentContent)?
                            root_parent==="0"?
                                <div className='flex gap-3 cursor-pointer items-center opacity-50' onClick={()=>{showAlert("This comment is blocked by admin.","warn")}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                    </svg>
                                    <div className='heart-empty-img-elem w-[17px] h-[17px] mt-1' title='Like'></div>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" strokeWidth={1.5} stroke="currentColor" className="w-[17px] h-[17px] mt-1">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                    </svg>
                                </div>
                            :
                                <div className='flex gap-3 cursor-pointer items-center opacity-50' onClick={()=>{showAlert("This comment is blocked by admin.","warn")}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" strokeWidth={1.5} stroke="currentColor" className="w-[17px] h-[17px] mt-1">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                    </svg>
                                </div>
                        :
                        <div className='flex gap-3 cursor-pointer items-center'>
                            {
                                comment_user!==undefined&&loggedUser!==undefined&&comment_user===loggedUser?
                                <button className='flex gap-2' onClick={()=>{setIsEditModalOpen(true)}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                    </svg>
                                </button>
                                :
                                null
                            }

                            {
                                involvementCount?
                                    <div className='flex gap-2 items-center' title='Total users involved'>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-[20px]">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
                                        </svg>
                                        <span>{involvementCount}</span>
                                    </div>
                                :
                                    null
                            }

                            {
                                comment_parent==="0"?
                                    likeStatus!=="loading"?
                                        comment_mode==='post'&&likeStatus!=="error"?
                                            <div className='flex gap-2 cursor-pointer'>
                                                {
                                                    likeStatus!==null&&likeStatus!=="dislike"?<img src='/images/heart-solid.svg' width="17" height="17" alt="Liked" title='Dislike' onClick={()=>{likeFunc(comment_id,likeStatus)}}/>:<div className='heart-empty-img-elem w-[17px] h-[17px] mt-1' title='Like' onClick={()=>{likeFunc(comment_id,likeStatus)}}></div>
                                                }
                                                <span>{likeCount}</span>
                                            </div>
                                        :
                                            <div className='flex gap-2 cursor-pointer' onClick={()=>{
                                                window.open('/login?ref=1');
                                            }}>
                                                {
                                                    <div className='heart-empty-img-elem w-[17px] h-[17px] mt-1'></div>
                                                }
                                                <span>{like_count}</span>
                                            </div>
                                    :
                                        <LoaderCircle/>
                                :
                                    null
                            }
        
                            {
                                modalFunc?
                                    <div className='flex gap-2' onClick={()=>{}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" strokeWidth={1.5} stroke="currentColor" className="w-[17px] h-[17px] mt-1">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                        </svg>
                                        <span>{cmnt_count===null?"0":cmnt_count}</span>
                                    </div>
                                :
                                    comment_parent==="0"?
                                        <a href={'/comments/view-hadith-comment?cmroot='+comment_id} target='_blank' className='flex gap-2' title='View comment'>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" strokeWidth={1.5} stroke="currentColor" className="w-[17px] h-[17px] mt-1">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                            </svg>
                                            <span>{cmnt_count===null?"0":cmnt_count}</span>
                                        </a>
                                    :
                                        <a href={`/comments/view-hadith-comment?cmroot=${root_parent}&reply=${comment_id}`} target='_blank' className='flex gap-2' title='View comment'>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" strokeWidth={1.5} stroke="currentColor" className="w-[17px] h-[17px] mt-1">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                            </svg>
                                        </a>
                            }
                        </div>
                    }
                    
                </div>
                {
                    isEditModalOpen&&
                    <AlimModalMedium modalFunc={setIsEditModalOpen}>
                        <div className="alim-text-color-style">
                            <h3 className='mb-4'>Edit comment</h3>
                            <EditComment webToken={alimToken} commentId={comment_id} commentText={commentContent} commentFunc={setCommentContent} modalFunc={setIsEditModalOpen} pageType={"hadith"}/>
                        </div>
                    </AlimModalMedium>
                }
            </div>
        );
    }
}

export default CommentBlock;